import { useFetchAgreementUrlLazy, useSendAgreement } from '@MP/shared/api/hooks/patient';

import type { PatientAgreementRepository } from '../stores/PatientAgreementSendViewModel';

/** 동의서 전송 ViewModel이 소비할 데이터 접근 계층을 조립한다(배선 전용, 비즈니스 로직 없음). */
const usePatientAgreementRepository = (): PatientAgreementRepository => {
  const fetchUrl = useFetchAgreementUrlLazy();
  const { mutateAsync: send } = useSendAgreement();

  return { fetchUrl, send };
};

export default usePatientAgreementRepository;
